import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

export const router: Routes = [
  {
    path: 'graduacao',
    loadChildren: 'app/graduacao/graduacao.module#GraduacaoModule',
  },
  {
    path: 'paginas',
    loadChildren: 'app/paginas/paginas.module#PaginasModule',
  },
  {
    path: 'restrito',
    loadChildren: 'app/restrito/restrito.module#RestritoModule',
  },
  {
    path: 'vestibular',
    loadChildren: 'app/vestibular/vestibular.module#VestibularModule',
  },
  {
    path: 'universidade',
    loadChildren: 'app/universidade/universidade.module#UniversidadeModule',
  },
  {
    path: 'biblioteca',
    loadChildren: 'app/biblioteca/biblioteca.module#BibliotecaModule',
  },
  {
    path: 'login',
    loadChildren: 'app/login/login.module#LoginModule',
  },
  {
    path: 'acessibilidade',
    loadChildren: 'app/acessibilidade/acessibilidade.module#AcessibilidadeModule',
  },
  {
    path: 'ouvidoria',
    loadChildren: 'app/ouvidoria/ouvidoria.module#OuvidoriaModule'
  },
  {
    path: '',
    loadChildren: 'app/home/home.module#HomeModule',
  },
  {
    path: 'pos-graduacao',
    loadChildren: 'app/pos-graduacao/pos-graduacao.module#PosGraduacaoModule',
  },
  {
    path: 'rematricula',
    loadChildren: 'app/matricula/matricula.module#MatriculaModule',
  },
  {
    path: 'pesquisa',
    loadChildren: 'app/pesquisa/pesquisa.module#PesquisaModule',
  },
  {
    path: 'extensao',
    loadChildren: 'app/extensao/extensao.module#ExtensaoModule',
  },
  {
    path: 'calculadora-ceuma',
    loadChildren: 'app/calculadora-ceuma/calculadora-ceuma.module#CalculadoraCeumaModule',
  },
  {
    path: 'calculadora-euro',
    loadChildren: 'app/calculadora-euro/calculadora-euro.module#CalculadoraEuroModule',
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

export const AppRouter: ModuleWithProviders = RouterModule.forRoot(router);
